import { render, staticRenderFns } from "./simple_error.vue?vue&type=template&id=48e216c8&scoped=true&"
import script from "./simple_error.vue?vue&type=script&lang=js&"
export * from "./simple_error.vue?vue&type=script&lang=js&"
import style0 from "./simple_error.vue?vue&type=style&index=0&id=48e216c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e216c8",
  null
  
)

export default component.exports